import AdminFormsPage from './forms';
export default AdminFormsPage;
